import {create} from 'zustand';
import type {UseConciergeDrawerStoreProps} from './types';

export const useConciergeDrawerStore = create<UseConciergeDrawerStoreProps>(set => ({
	isOpen: false,
	onOpen: () => set({isOpen: true}),
	onClose: () => set({isOpen: false}),
}));
